export const INVOICES_LIST_REQUEST = "INVOICES_LIST_REQUEST";
export const INVOICES_LIST_SUCCESS = "INVOICES_LIST_SUCCESS";
export const INVOICES_LIST_FAILURE = "INVOICES_LIST_FAILURE";

export const PAYMENT_LIST_REQUEST = "PAYMENT_LIST_REQUEST";
export const PAYMENT_LIST_SUCCESS = "PAYMENT_LIST_SUCCESS";
export const PAYMENT_LIST_FAILURE = "PAYMENT_LIST_FAILURE";

export const RESET_INVOICE_LIST = "RESET_INVOICE_LIST";
